export default __webpack_public_path__ + "0fc7c98ab5c2af84645a728f6086a157.png";